// AB-Modul: PDF-Arbeitsplatz/Detail-Ausbau (Welle "UI-Paritaet", Agent FE-2).
// Key-Praefix bleibt 'abPdf.' (eigene Datei neben ab.de.js, s. BAUPLAN-AB-UI-PARITAET).
const abPdf = {
  // ---- PDF-Viewer (Toolbar/Zustaende) ----
  'abPdf.zoomOut': 'Verkleinern',
  'abPdf.zoomIn': 'Vergrößern',
  'abPdf.zoomReset': 'Zurücksetzen',
  'abPdf.findingsToggle': 'Fundstellen',
  'abPdf.findingsHint': 'Markiert im PDF, woher die Tabellenwerte stammen. Ein Feld rechts anklicken hebt seine Fundstelle hervor.',
  'abPdf.pdfLoading': 'PDF wird geladen…',
  'abPdf.pdfLoadError': 'PDF konnte nicht geladen werden',
  'abPdf.pdfRetry': 'Erneut versuchen',
  'abPdf.pdfEmpty': 'Kein PDF verfügbar',

  // ---- Klick-Übernahme-Modus ----
  'abPdf.pickHintIdle': 'Tipp: Feld anklicken, dann links im PDF auf den passenden Text klicken — der Wert wird übernommen.',
  'abPdf.pickHintActive': 'Aktiv: Pos {line} · {field} — jetzt links im PDF auf den Wert klicken (erster Klick ersetzt, weitere hängen an). Esc beendet.',

  // ---- Supersede-Banner ----
  'abPdf.supersedeTitle': 'Neuere Auftragsbestätigung vorhanden',
  'abPdf.supersedeMsg': 'Zu dieser Bestellung ist eine neuere AB eingegangen ({fileName}, {date}). Es sollte nur die aktuellste AB nach SAP übertragen werden — ältere ABs sind überholt.',
  'abPdf.supersedeOpen': 'Neueste AB öffnen',

  // ---- Abgleich-/HTN-Panel ----
  'abPdf.compareLoading': 'Abgleich mit offenen SAP-Bestellungen läuft…',
  'abPdf.compareUnavailableTitle': 'Bestell-Abgleich nicht möglich',
  'abPdf.compareUnavailableMsg': 'Der Abgleich mit der SAP-Bestellung ist aktuell nicht möglich (z. B. Zeitüberschreitung). Die Felder können trotzdem geprüft und übertragen werden; der Abgleich greift beim nächsten Öffnen erneut.',
  'abPdf.compareNoneFoundTitle': 'Keine offene SAP-Bestellung gefunden',
  'abPdf.compareNoneFoundMsg': 'Es wurde keine offene SAP-Bestellung zu diesen Positionen gefunden (Bestellnr. {orders}) — in dieser SAP-Umgebung vermutlich nicht vorhanden. Die Felder können trotzdem geprüft werden.',
  'abPdf.compareCheckedTitle': 'Mit offenen SAP-Bestellungen geprüft',
  'abPdf.compareCheckedMsg': '{matched} von {total} Position(en) zugeordnet',
  'abPdf.compareDiffSuffix': ', {n} Abweichung(en)',
  'abPdf.compareNotFoundSuffix': ', {n} ohne Bestellung',
  'abPdf.htnCheckButton': 'HTN prüfen',
  'abPdf.htnChecking': 'Prüfe HTN…',
  'abPdf.htnResultTitle': 'HTN-Prüfung (AMPL-Freigabeliste)',
  'abPdf.htnResultOkClean': 'Alle Herstellerteilenummern geprüft — in Ordnung.',
  'abPdf.htnResultOkWithMissing': 'Alle Herstellerteilenummern geprüft, {n} ohne HTN.',
  'abPdf.htnResultProblemBase': '{mismatch} Position(en) mit nicht freigegebener HTN',
  'abPdf.htnResultProblemMissingSuffix': ', {missing} ohne HTN',
  'abPdf.htnMatch': 'HTN ✓',
  'abPdf.htnMatchTooltip': 'Freigegebene Herstellerteilenr. (AMPL)',
  'abPdf.htnMismatch': 'HTN ≠',
  'abPdf.htnMismatchTooltip': 'Nicht freigegeben — gültig laut AMPL: {valid}',
  'abPdf.htnMissing': 'HTN ?',
  'abPdf.htnMissingTooltip': 'Keine HTN extrahiert — gültig laut AMPL: {valid}',
  'abPdf.poAdoptTooltip': 'Aus Bestellung übernehmen: {value}',

  // ---- Pflichtfeld-Panel ----
  'abPdf.missingFieldsTitle': 'Bitte prüfen / ggf. manuell befüllen',
  'abPdf.missingFieldsMsg': 'Folgende Felder sind in mindestens einer Position leer und konnten nicht automatisch zugewiesen werden: {fields}. Werte direkt in der Tabelle eintragen (gelb markierte Felder), bevor du nach SAP überträgst.',

  // ---- Einteilung-Spalte ----
  'abPdf.einteilungLabel': 'Einteilung',
  'abPdf.einteilungHint': 'Liefereinteilung je Bestellposition — frei editierbar (kein SAP-Feld, dient dem Mengen-Abgleich)',
  'abPdf.eeindPoHint': 'Best.: {date}',

  // ---- E-Mail-Kontext ----
  'abPdf.emailContextTitle': 'E-Mail-Kontext',
  'abPdf.emailSubjectLabel': 'Betreff',
  'abPdf.emailBodyEmpty': 'Kein E-Mail-Text gespeichert.',
  'abPdf.emailOpenMailButton': 'Mail-Nachricht öffnen',

  // ---- Sibling-Umschalter (Anhänge derselben Mail) ----
  'abPdf.attachmentOf': 'Anhang {n} von {total}',
  'abPdf.attachmentPrev': 'Vorheriger Anhang',
  'abPdf.attachmentNext': 'Nächster Anhang',

  // ---- Melden-Workflow ----
  'abPdf.reportButton': 'Melden',
  'abPdf.reportedBadge': '✓ Gemeldet',
  'abPdf.reportAlreadyReported': 'Dokument ist bereits gemeldet — wartet auf Freigabe durch einen Administrator.',
  'abPdf.reportResolveButton': 'Meldung lösen',
  'abPdf.reportDialogTitle': 'Dokument melden',
  'abPdf.reportDialogMsg': 'Beschreibe kurz das Problem beim Mapping. Ein Administrator prüft das Dokument; der Kommentar ist Pflicht.',
  'abPdf.reportResolveDialogTitle': 'Meldung lösen',
  'abPdf.reportResolveDialogMsg': 'Hinterlasse einen Kommentar zur Freigabe. Das Dokument wird freigegeben. Der Kommentar ist Pflicht.',
  'abPdf.reportCommentPlaceholder': 'Kommentar…',
  'abPdf.reportCommentRequired': 'Bitte einen Kommentar angeben',
  'abPdf.reportSubmittedMsg': 'Dokument gemeldet',
  'abPdf.reportResolvedMsg': 'Meldung gelöst',
  'abPdf.reportHistoryTitle': 'Melde-Historie',
  'abPdf.reportHistoryReported': 'gemeldet',
  'abPdf.reportHistoryResolved': 'gelöst',

  // ---- Rohtext / Feld-Mapping ----
  'abPdf.rawTextTitle': 'Erkannten Rohtext anzeigen',
  'abPdf.mappingButton': 'PDF & Feld-Mapping',
};

export default abPdf;
